export default __webpack_public_path__ + "static/media/hungary.730b92d3.svg";